import React, { useState } from 'react';
import Tile from '../ui/Tile';
import TileHeader from '../ui/TileHeader';
import { Download } from 'lucide-react';
import Input from '../ui/Input';
import Label from '../ui/Label';
import Button from '../ui/Button';
import { getTenantId } from '../AuthService';

const ExportDataTile = ({ handleExportCsv, handleExportExcel, handleExportXml }) => {
  const tenantId = getTenantId();
  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 2).toISOString().split('T')[0];
  const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1).toISOString().split('T')[0];

  const [startDate, setStartDate] = useState(startOfMonth);
  const [endDate, setEndDate] = useState(endOfMonth);

  return (
    <div className="w-full mt-8">
      <Tile>
        <TileHeader title="Експорт на данни" icon={Download} />
        <div className="p-6">
          <div className="bg-gray-50/50 rounded-xl p-6 flex flex-col md:flex-row justify-between items-start md:items-end gap-6">
          
          {/* Dates Column */}
          <div className="flex flex-col gap-5 w-full md:w-auto">
            <div className="w-full md:w-[240px]">
              <Label>Начална дата</Label>
              <Input 
                type="date" 
                value={startDate} 
                onChange={e => setStartDate(e.target.value)}
              />
            </div>
            
            <div className="w-full md:w-[240px]">
              <Label>Крайна дата</Label>
              <Input 
                type="date" 
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
              />
            </div>
          </div>

          {/* Buttons Column */}
          <div className="flex flex-col gap-3 w-full md:w-auto mt-4 md:mt-0">
            <Button 
              onClick={() => handleExportCsv && handleExportCsv(startDate, endDate)}
              variant="primary" 
              className="w-full md:w-auto"
            >
              Експорт в CSV
            </Button>
            <Button 
              onClick={() => handleExportExcel && handleExportExcel(startDate, endDate)}
              variant="primary" 
              className="w-full md:w-auto"
            >
              Експорт в Excel
            </Button>
            {tenantId === '8a1c6c5b-0062-4555-abe4-98a992364e35' && (
              <Button 
                onClick={() => handleExportXml && handleExportXml(startDate, endDate)}
                variant="primary" 
                className="w-full md:w-auto"
              >
                Експорт в XML
              </Button>
            )}
          </div>
        </div>
        </div>
      </Tile>
    </div>
  );
};

export default ExportDataTile;
